import bFormTextArea from 'bootstrap-vue/es/components/form-textarea/form-textarea';

var pyFormTextArea = {
  name: 'pyFormTextArea',
  extends: bFormTextArea,
  methods:{
    focus: function(e){
      this.$parent.$emit('pyInputFocus', e.target);
    },
    blur: function(e){
      this.$parent.$emit('pyInputBlur', e.target);
    }
  },
  mounted: function(){
    this.$el.addEventListener("focus", this.focus)
    this.$el.addEventListener("blur", this.blur)
  }
};

export default pyFormTextArea;


